import { Injectable } from "@angular/core";
import { adminConstant } from "../constant/admin-constant";
import { HttpClient, HttpHeaders } from "@angular/common/http";
@Injectable({
  providedIn: "root",
})
export class AdminService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
  };

  constructor(private httpClient: HttpClient) {}

  //active karyakartas
  getActiveKaryakartaCount(officeId) {
    return this.httpClient.get(`${adminConstant.KARYAKARTA_COUNT}/true`);
  }
  //inactive karyakartas
  getInactiveKaryakartaCount(officeId) {
    return this.httpClient.get(`${adminConstant.KARYAKARTA_COUNT}/false`);
  }

  //document count
  getTotalDocumentCount(officeId) {
    //?
    return this.httpClient.get(`${adminConstant.DOCUMENTS_COUNT}`);
  }
  //recent document
  getNewlyAddedDocumentCount(officeId) {
    //?
    return this.httpClient.get(`${adminConstant.RECENT_DOCUMENT_COUNT}`);
  }

  getKeosksCount(officeId) {
    return this.httpClient.get(adminConstant.KEOSKS_COUNT + "/true");
  }

  getNotWorkingKeosksCount(officeId) {
    return this.httpClient.get(`${adminConstant.KEOSKS_COUNT}/false`);
  }

  //birthday count
  getBirthdayCountTotal() {
    return this.httpClient.get(`${adminConstant.BIRTHDAY_COUNT}`);
  }
}
